export const FAQ_ITEMS = [
  { key: "q1" },
  { key: "q2" },
  { key: "q3" },
  { key: "q4" },
];